import { Skeleton } from "@/components/ui/skeleton";

export const WhyChooseUsSkeleton = () => {
  return (
    <div className="bg-slate-50">
      <div className="container flex flex-col gap-8 py-12 lg:gap-24 lg:py-32">
        {/* Header section */}
        <div className="flex flex-col items-start justify-between gap-4 lg:flex-row lg:items-center">
          {/* Main heading */}
          <Skeleton className="mx-auto h-12 w-48 rounded-md lg:mx-0 lg:h-24 lg:w-80" />

          {/* Rating section */}
          <div className="flex w-full flex-col gap-1.5 lg:w-auto lg:gap-3">
            <Skeleton className="h-6 w-48 rounded-md lg:h-12 lg:w-64" />
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => (
                <Skeleton
                  key={i}
                  className="mr-1 size-4 rounded-full lg:mr-2 lg:size-8"
                />
              ))}
              <Skeleton className="ml-3 h-6 w-12 rounded-md lg:h-10 lg:w-20" />
            </div>
          </div>
        </div>

        {/* Reasons grid */}
        <div className="grid gap-4 lg:grid-cols-3 lg:gap-8">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="rounded-sm p-0.5">
              <div className="flex h-full flex-col gap-5 bg-white p-5 lg:gap-10 lg:p-10">
                {/* Icon placeholder */}
                <Skeleton className="size-12 rounded-md lg:size-16" />

                {/* Content */}
                <div className="flex flex-col gap-4">
                  <Skeleton className="h-8 w-3/4 rounded-md lg:h-10" />
                  <Skeleton className="h-6 w-full rounded-md lg:h-8" />
                  <Skeleton className="h-6 w-5/6 rounded-md lg:h-8" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
